import { render, staticRenderFns } from "./forgot_pass.vue?vue&type=template&id=2340f624&"
import script from "./forgot_pass.vue?vue&type=script&lang=js&"
export * from "./forgot_pass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2340f624')) {
      api.createRecord('2340f624', component.options)
    } else {
      api.reload('2340f624', component.options)
    }
    module.hot.accept("./forgot_pass.vue?vue&type=template&id=2340f624&", function () {
      api.rerender('2340f624', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/auth/forgot_pass.vue"
export default component.exports